import { Injectable } from "@angular/core";
import { IID_FEASABILITY_ASSOCIATION } from "@common/interfaces/interfaceData";
import { AbstractInterfaceDataQuery } from "../interfaceDataModel";
import { IIDFeasabilityAssociationStore } from "./iidFeasabilityAssociation.store";
import { InterfaceName } from "@common/interfaces/issueTypeInterface";
import { InterfaceDataQuery } from "../interfaceDataRegistry";

@Injectable({
  providedIn: 'root'
})
@InterfaceDataQuery(InterfaceName.IID_FEASABILITY_ASSOCIATION)
export class IIDFeasabilityAssociationQuery extends AbstractInterfaceDataQuery<IID_FEASABILITY_ASSOCIATION> {
  constructor(protected store: IIDFeasabilityAssociationStore) {
    super(store);
  }
}
